var render = function render(){var _vm=this,_c=_vm._self._c;return _c('default',[_c('div',{staticClass:"cust-pa-wrap"},[_c('pa-sale-page',{attrs:{"channel":"customer"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }